module.exports = "<h4 id=\"appbooster\">Appbooster</h4>\n<p><strong>Customer:</strong> Mobile apps marketing project</p>\n<p><strong>Description:</strong> Multiple systems for mobile apps promotion and app stores optimizations</p>\n<p><strong>Languages:</strong>​ Ruby</p>\n<p><strong>Position:</strong> Backend developer</p>\n<p><strong>Role:​</strong></p>\n<ul>\n<li>Development and support of project apis</li>\n<li>Different sources data scraping</li>\n<li>Proxies (developed and support load balancers)</li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/appbooster.md
// module id = r76T
// module chunks = 1